export default {
  normal: '0px 2px 16px -4px rgba(23, 30, 41, 0.08)',
  color: '0px 2px 16px rgba(241, 119, 47, 0.44)',
};
